document.addEventListener('DOMContentLoaded', function() {
    if (window.location.hash === '#opencart') {
        const cartButton = document.querySelector('.header__buttons a.cart-drawer-button');
        if (cartButton) {
            cartButton.click();
        }
    }
});



document.addEventListener('DOMContentLoaded', () => {

setTimeout(function() {
 const cartContainer = document.querySelector('.fcsb-mini-cart-sidebar');

if (cartContainer) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        hideSellingPlans();
        hideDropdownValue();
        const progressBar = document.querySelector('.fcsb-mini-cart-progress-bar');
        const bars = document.querySelectorAll('.fcsb-progress-bar');
         const allIcon = document.querySelectorAll('.fcsb-marker');
        
        const currentLevel = parseInt(getComputedStyle(progressBar).getPropertyValue('--current-level').trim());
        bars.forEach((bar) => {
            if (currentLevel === 1) {
                bar.style.backgroundColor = '#25501E';
            } else {
                bar.style.backgroundColor = '#ED5600FF';
              
            }
        });
         allIcon.forEach((icon) => {
            if (currentLevel === 1) {
               icon.style.backgroundColor = '#25501E'; 
               icon.style.color = '#F7F5ED';
               icon.style.border = '2px solid #FFFFFF';

            } else {
                icon.style.backgroundColor = '#ED5600FF'; 
                icon.style.color = '#F7F5ED';
                // icon.style.border = '#FFFFFF';
            }
        });

      }
    });
  });

  const config = { childList: true, subtree: true };
  observer.observe(cartContainer, config);
} else {
  console.error('Cart container not found!');
}

},2000)

  
  const columns = document.querySelectorAll('.f-column');

  columns.forEach(column => {
    const linkElement = column.querySelector('.multicolumn-card__info a'); // Find the anchor tag inside the column
    
    if (linkElement && linkElement.hasAttribute('href') && linkElement.getAttribute('href').trim() !== '') {
      const hrefValue = linkElement.getAttribute('href'); // Get the href value
      column.style.cursor = 'pointer';

      // Add click event listener to the parent column
      column.addEventListener('click', () => {
        window.location.href = hrefValue; // Redirect to the link
      });
    }
  });

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

const tabButtons = document.querySelectorAll('.tabs__nav button');
const imageDivs = document.querySelectorAll('.collage-tab__images');
function onTabClick(event) {
    let clickedIndex = parseInt(event.target.getAttribute('data-index')) + 1; 
    if (isNaN(clickedIndex)) {
        clickedIndex = parseInt(event.target.closest('button').getAttribute('data-index')) + 1; 
    }
    imageDivs.forEach((imageDiv) => {
        const imageIndex = parseInt(imageDiv.getAttribute('data-imageindex')); 
        console.log("imageIndex",imageIndex,clickedIndex)
        if (imageIndex === clickedIndex) {
            imageDiv.classList.remove('hide');
        } else {
            imageDiv.classList.add('hide');
        }
    });
}

tabButtons.forEach((button) => {
    button.addEventListener('click', onTabClick);
});

  
// setTimeout(function(){
//   var newDiv = document.createElement("div");

// // Add text to the new div
// newDiv.textContent = "Fill out the details below to track your order status.";
//  newDiv.className = "order-text";
// // Find the existing div with the ID 'track123_input_container'
// var existingDiv = document.querySelector(".track123_input_container");

// // Insert the new div before the existing one
// existingDiv.parentNode.insertBefore(newDiv, existingDiv);
// },4000)

 if (document.body.classList.contains('product-template')) {
        const select = document.querySelector('.skio-frequency');
        
        // Check if the select element has only one option
        if (select && select.options.length === 1) {
            select.style.backgroundColor = 'transparent'; 
            select.style.pointerEvents = 'none'; 
        }
    }






  


setTimeout(function(){
const img = document.createElement('img');
  img.src = 'https://cdn.shopify.com/s/files/1/0651/4769/9362/files/XMLID_00000166660429941641759480000004138340903039802298__1.svg?v=1737719073'; 
  img.alt = 'Empty Cart Image'; 
  img.height = 64;  // Don't use px, just the number value
  img.width = 64;   // Same here, just the number value
  img.style.paddingBottom = '24px';  // Correct camelCase syntax
  img.style.display = 'block';

  const cartEmptyText = document.querySelector('.fcsb-mini-cart-empty span');
  cartEmptyText.parentNode.insertBefore(img, cartEmptyText);

  // Create the image element
  const cartIcon = document.createElement('img');
  cartIcon.src = 'https://cdn.shopify.com/s/files/1/0651/4769/9362/files/Cart.svg?v=1737719073'; // Replace with your image URL
  cartIcon.alt = 'Image description';
  cartIcon.style.width = '24px'; // Adjust width as needed
  cartIcon.style.height = '24px'; // Adjust height as needed
  cartIcon.style.marginRight = '16px'; // Adjust margin as needed
  // Get the title container
  const titleContainer = document.querySelector('.fcsb-title');

  titleContainer.insertBefore(cartIcon, titleContainer.firstChild);

 },3000)


  if(document.querySelector(".fcsb-add-button")){
  document.querySelector(".fcsb-add-button").addEventListener("click", function() {
  setTimeout(function(){
    hideSellingPlans();
  },4000)
})
}
  
});

if(document.getElementById("readMoreBtn")){
  document.getElementById("readMoreBtn").addEventListener("click", function() {
  let hiddenFaqs = document.querySelectorAll(".hidden-faq");
  let allFaqs = document.querySelectorAll(".mobile-tab.accordion-item");
  let button = document.getElementById("readMoreBtn");
  let PlusIcon = document.querySelector(".icon-plus");
  let PlusMinus = document.querySelector(".icon-minus");

  if (button.innerHTML.includes("Read More")) {
    hiddenFaqs.forEach(faq => {
      faq.classList.remove("hidden-faq");
    });
    button.firstChild.textContent = "Read Less";
    PlusIcon.classList.add("hide");
    PlusMinus.classList.remove("hide");
  } else {
    for (let i = 7; i < allFaqs.length; i++) {
      allFaqs[i].classList.add("hidden-faq");
    }
    button.firstChild.textContent = "Read More";
     PlusIcon.classList.remove("hide");
    PlusMinus.classList.add("hide");
  }
});

}



function hideSellingPlans() {
   var productContainers = document.querySelectorAll('[data-cl="minicart-product-container"]');
    productContainers.forEach(function(container) {
    var variantTitleElement = container.querySelector('[data-cl="minicart-variant-title"]');
    var variantTitle = variantTitleElement ? variantTitleElement.getAttribute("title") : "";
    var sellingPlans = container.querySelector('.fcsb-selling-plans');
    if (variantTitle === "30ml") {
        if (sellingPlans) {
            sellingPlans.style.display = 'block'; 
        }
    } else {
        if (sellingPlans) {
            sellingPlans.style.display = 'none'; 
        }
    }
  });
}

function hideDropdownValue() {
  document.querySelectorAll('optgroup[label="Subscription"]').forEach(function(optgroup) {
        while (optgroup.firstChild) {
            optgroup.parentNode.insertBefore(optgroup.firstChild, optgroup.nextSibling);
        }
        
        optgroup.remove();
    });
}

if (window.location.href === 'https://auranaturals.com/cart') {
  window.location.href = 'https://auranaturals.com/#opencart';
}





/*sticky ATC with kaching*/
$(document).ready(function () {
  let attempts = 0;
  const maxAttempts = 7;
  const interval = 500;
  const DOM_UPDATE_DELAY = 1200;

  function updateStickyQuantity(bottleCount) {
    const $qtyInput = $('#QuantitySticky-sticky-atc-bar input.quantity__input');
    if ($qtyInput.length) {
      console.log(`[DEBUG] Setting sticky ATC quantity to: ${bottleCount}`);
      $qtyInput.val(bottleCount).trigger('change');
    } else {
      console.warn('[DEBUG] Sticky ATC quantity input not found.');
    }
  }

  function getBottleCountFromSelected() {
    const $selected = $('.kaching-bundles__bar--selected');
    addFreeShippingLabel();
    if ($selected.length) {
      const text = $selected.find('.kaching-bundles__bar-title').text().trim();
      const match = text.match(/^(\d+)\s+Bottle/);
      if (match) {
        const count = parseInt(match[1], 10);
        console.log(`[DEBUG] Detected selected bundle: ${count} Bottle(s)`);
        return count;
      }
    }
    console.warn('[DEBUG] Could not determine bottle count from selected bundle.');
    return null;
  }

  function attachBundleListener() {
    console.log('[DEBUG] Attaching bundle radio change listener.');
    $('.kaching-bundles__bar input[type="radio"]').off('change').on('change', function () {
      console.log('[DEBUG] Bundle selection changed.');
      const count = getBottleCountFromSelected();
      if (count !== null) {
        updateStickyQuantity(count);
      }
    });
  }

  function syncBundleToStickyATC() {
    attachBundleListener(); // reattach first
    const count = getBottleCountFromSelected();
    if (count !== null) {
      updateStickyQuantity(count);
    }
  }

function handleVariantChange(source = 'unknown') {
  console.log(`[DEBUG] Variant changed via ${source}. Waiting for DOM update...`);
  addFreeShippingLabel();
  setTimeout(() => {
    console.log('[DEBUG] Re-attaching bundle logic after variant change.');
    syncBundleToStickyATC();
    addFreeShippingLabel();
  }, DOM_UPDATE_DELAY);
}

function addFreeShippingLabel() {
  document.querySelectorAll('.kaching-bundles__bar-wrapper .kaching-bundles__bar-price').forEach(priceEl => {
    const priceValue = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
    if (priceValue > 75) {
      const parentWrapper = priceEl.closest('.kaching-bundles__bar-wrapper');
      if (parentWrapper) {
        const subtitleEl = parentWrapper.querySelector('.kaching-bundles__bar-subtitle');
        if (subtitleEl && !subtitleEl.textContent.includes('| Free Shipping')) {
          subtitleEl.textContent += ' | Free Shipping';
        }
      }
    }
  });
}

  function bindVariantChangeListeners() {
    const $stickySelect = $('.sticky-atc-bar__variant-select');
    if ($stickySelect.length) {
      console.log('[DEBUG] Found sticky variant dropdown. Attaching change listener.');
      $stickySelect.off('change').on('change', function () {
        handleVariantChange('sticky dropdown');
      });
    }

    const wrapper = document.querySelector('.product__block--variant_picker');
    if (!wrapper) {
      console.warn('[DEBUG] Variant picker wrapper not found.');
      return;
    }

    function observeVariantSelectComponent(variantSelectEl) {
      if (!variantSelectEl) return;

      console.log('[DEBUG] Observing <variant-selects> for internal changes...');
      const observer = new MutationObserver(() => {
        console.log('[DEBUG] Detected mutation inside <variant-selects>. Reapplying bundle sync.');
        handleVariantChange('main variant observer');
      });

      observer.observe(variantSelectEl, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    // Initial observer if already present
    const initial = wrapper.querySelector('variant-selects');
    if (initial) observeVariantSelectComponent(initial);

    // Watch wrapper for replacement of <variant-selects>
    const wrapperObserver = new MutationObserver(() => {
      const updated = wrapper.querySelector('variant-selects');
      if (updated) {
        console.log('[DEBUG] New <variant-selects> detected. Rebinding observer.');
        observeVariantSelectComponent(updated);
      }
    });

    wrapperObserver.observe(wrapper, {
      childList: true,
      subtree: true,
    });
  }

  const retryInterval = setInterval(function () {
    const $bars = $('.kaching-bundles__bar');

    if ($bars.length > 0) {
      console.log('[DEBUG] Found initial bundle elements.');
      clearInterval(retryInterval);

      syncBundleToStickyATC();
      bindVariantChangeListeners();
    } else {
      attempts++;
      console.log(`[DEBUG] Waiting for bundle block... (${attempts}/${maxAttempts})`);
      if (attempts >= maxAttempts) {
        clearInterval(retryInterval);
        console.warn('[DEBUG] Max attempts reached. Bundle block not found.');
      }
    }
  }, interval);
});









(function() {
  if (!window.location.search.includes('view=discount-collection')) return;

  const toast = document.createElement('div');
  toast.id = 'discount-toast-overlay';
  toast.innerHTML = `
    <div id="discount-toast">
      <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
        <span style="font-size:20px;">🎉</span>
        <strong style="font-size:14px;color:#1a1a1a;">$20 Discount Applied!</strong>
      </div>
      <p style="margin:0 0 12px;font-size:13px;color:#444;line-height:1.4;">
        Please choose a subscription plan to use your discount.
      </p>
      <button id="discount-toast-btn">OK, Got It</button>
    </div>
  `;

  const style = document.createElement('style');
  style.textContent = `
    #discount-toast-overlay {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%) translateY(100px);
      z-index: 99999;
      opacity: 0;
      transition: transform 0.4s cubic-bezier(0.16,1,0.3,1), opacity 0.4s ease;
      max-width: 90vw;
      width: 340px;
    }
    #discount-toast-overlay.show {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
    #discount-toast-overlay.hide {
      transform: translateX(-50%) translateY(100px);
      opacity: 0;
    }
    #discount-toast {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);
    }
    #discount-toast-btn {
      display: block;
      width: 100%;
      padding: 10px;
      background: #3a1f15;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s;
    }
    #discount-toast-btn:hover {
      background: #2a1510;
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(toast);

  setTimeout(() => toast.classList.add('show'), 500);

  document.getElementById('discount-toast-btn').addEventListener('click', function() {
    toast.classList.remove('show');
    toast.classList.add('hide');
    setTimeout(() => toast.remove(), 400);
  });

  setTimeout(() => {
    if (document.getElementById('discount-toast-overlay')) {
      toast.classList.remove('show');
      toast.classList.add('hide');
      setTimeout(() => toast.remove(), 400);
    }
  }, 8000);
})();